import { apiClient } from './client';

export type CompanyCalendarEventType =
  | 'meeting'
  | 'dinner'
  | 'training'
  | 'weekend'
  | 'external';

export interface CompanyCalendarEvent {
  eventId: number;
  eventDate: string;
  title: string;
  content?: string | null;
  eventType: CompanyCalendarEventType | string;
  createdUserId?: number | null;
  createdUserName?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface CompanyCalendarEventPayload {
  eventDate: string;
  title: string;
  content?: string;
  eventType?: CompanyCalendarEventType | string;
}

export async function fetchCompanyCalendarEvents(
  from: string,
  to: string
): Promise<CompanyCalendarEvent[]> {
  const { data } = await apiClient.get<CompanyCalendarEvent[]>('/calendar-events', {
    params: { from, to },
  });
  return data;
}

export async function createCompanyCalendarEvent(
  payload: CompanyCalendarEventPayload
): Promise<CompanyCalendarEvent> {
  const { data } = await apiClient.post<CompanyCalendarEvent>('/calendar-events', payload);
  return data;
}

export async function updateCompanyCalendarEvent(
  eventId: number,
  payload: CompanyCalendarEventPayload
): Promise<CompanyCalendarEvent> {
  const { data } = await apiClient.patch<CompanyCalendarEvent>(
    `/calendar-events/${eventId}`,
    payload
  );
  return data;
}

export async function deleteCompanyCalendarEvent(eventId: number): Promise<void> {
  await apiClient.delete(`/calendar-events/${eventId}`);
}
